// Exporting all action-creators from this single point.
// Add additional action-creator files as needed
export * from './app';
export * from './contacts';
export * from './login';
export * from './phone';
export * from './settings';



// WEBPACK FOOTER //
// ./src/action-creators/index.js